import React from "react";
import ReactToPrint from "react-to-print";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {
  // year9Case,
  year9Case20220511,
  // prostate9yearCase,
  year9CaseProstate20220511,
  newlungAgeChecker,
  newProstateAgeChecker,
  newDefaultProstateAgeChecker,
  newDefaultlungAgeChecker,
  heightCheckermm,
  getBreastCancerScore,
} from "../../utils/calculate";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import { sexCheck } from "../../utils/cancerCalView";
// import { sexCheck } from "../../../utils/cancerCalView";

const diplayStyle = {
  display: "none",
};
const printStyle = {
  root: {
    paddingTop: "1mm",
  },
  logo: {
    backgroundImage: "url(/images/logo-korean.jpg)",
    backgroundRepeat: "no-repeat",
    width: 156,
    height: 58,
    marginRight: "8mm",
  },
  detail: {
    border: "1px solid #e3e3e3",
    marginTop: "3mm",
    fontSize: 14,
    padding: "4mm",
    width: "186mm",
  },
  detail2: {
    border: "1px solid #e3e3e3",
    marginTop: "3mm",
    fontSize: 14,
    // padding: "4mm",
    width: "194mm",
  },
  detail3: {
    border: "1px solid #e3e3e3",
    marginTop: "3mm",
    fontSize: 14,
    width: "194mm",
  },
  detail2Header: {
    // borderBottom: "1px solid #dbdbdb",
    background: "#f2f2f2",
    textAlign: "center",
    paddingTop: "3mm",
    paddingBottom: "3mm",
    fontWeight: 600,
    fontSize: 14,
  },
  detail3Header: {
    background: "#f2f2f2",
    textAlign: "center",
    paddingTop: "3mm",
    paddingBottom: "3mm",
    borderBottom: "1px solid #e3e3e3",
  },
  headerLine: {
    width: "119mm",
    height: "100%",
  },
  headerSubLine: {
    flex: 1,
    borderLeft: "1px solid #e3e3e3",
    height: "100%",
  },
  detail2Body: {
    // borderBottom: "1px solid #dbdbdb",
    // padding: "4mm",
  },
  detail2Body1: {
    textAlign: "center",
    fontWeight: 600,
    paddingTop: "2mm",
    paddingBottom: "2mm",
  },
  detail2Body2: {
    textAlign: "center",
    // fontWeight: 600,
    paddingTop: "2mm",
    paddingBottom: "2mm",
  },
  detail2Left: {
    width: "60mm",
  },
  detail2Right: {
    width: "60mm",
    // width: "100mm",
  },
  detail2Left2: {
    width: "60mm",
  },
  grapLineHeight: {
    height: "100%",
    width: "15mm",
  },
  // grapLine: {
  //   height: "90%",
  //   width: "15mm",
  //   background: "#ff8686",
  // },

  grapLine1: {
    // height: "40mm",
    width: "15mm",
    background: "#ff8686",
  },
  grapLine11: {
    height: "100%",
    width: "15mm",
    background: "#ff8686",
  },
  grapLine12: {
    height: "15%",
    width: "15mm",
    background: "#ff8686",
  },
  grapLine13: {
    height: "20%",
    width: "15mm",
    background: "#ff8686",
  },
  grapLine14: {
    height: "25%",
    width: "15mm",
    background: "#ff8686",
  },
  grapLine15: {
    height: "30%",
    width: "15mm",
    background: "#ff8686",
  },
  grapLine16: {
    height: "40%",
    width: "15mm",
    background: "#ff8686",
  },
  grapLine17: {
    height: "50%",
    width: "15mm",
    background: "#ff8686",
  },

  grapLine2: {
    width: "15mm",
    background: "#ffb986",
  },
  grapLine21: {
    height: "10%",
    width: "15mm",
    background: "#ffb986",
  },
  grapLine22: {
    height: "15%",
    width: "15mm",
    background: "#ffb986",
  },
  grapLine23: {
    height: "20%",
    width: "15mm",
    background: "#ffb986",
  },
  grapLine24: {
    height: "25%",
    width: "15mm",
    background: "#ffb986",
  },
  grapLine25: {
    height: "30%",
    width: "15mm",
    background: "#ffb986",
  },
  grapLine26: {
    height: "40%",
    width: "15mm",
    background: "#ffb986",
  },
  grapLine27: {
    height: "50%",
    width: "15mm",
    background: "#ffb986",
  },

  grapLine3: {
    width: "15mm",
    background: "#03a9f4",
  },
  grapLine31: {
    height: "10%",
    width: "15mm",
    background: "#03a9f4",
  },
  grapLine32: {
    height: "15%",
    width: "15mm",
    background: "#03a9f4",
  },
  grapLine33: {
    height: "20%",
    width: "15mm",
    background: "#03a9f4",
  },
  grapLine34: {
    height: "25%",
    width: "15mm",
    background: "#03a9f4",
  },
  grapLine35: {
    height: "30%",
    width: "15mm",
    background: "#03a9f4",
  },
  grapLine36: {
    height: "40%",
    width: "15mm",
    background: "#03a9f4",
  },
  grapLine37: {
    height: "50%",
    width: "15mm",
    background: "#03a9f4",
  },

  grapText: {
    textAlign: "right",
    fontWeight: 600,
    width: "18mm",
    // height: "100%",
    // width: "13mm",
    // background: "red",
  },
  grapTitle: {
    marginBottom: "2mm",
  },

  detail2Footer: {
    borderTop: "1px solid #e3e3e3",
    padding: "4mm",
    fontSize: 14,
  },
  detailCont: {
    marginBottom: "2mm",
    color: "#000000",
    fontWeight: 500,
    lineHeight: 1.4,
  },
  detailCont2: {
    color: "#000000",
    fontWeight: 500,
    lineHeight: 1.4,
  },
  detailContSub: {
    marginBottom: "2mm",
    color: "#8b8b8b",
    fontSize: 11,
    fontWeight: 500,
  },
  detailGraph: {
    border: "1px solid #dbdbdb",
    marginTop: "4mm",
    fontSize: 14,
    padding: "4mm",
    width: "186mm",
  },
  grap: {
    height: "24mm",
  },
  header: {
    marginTop: 88,
    marginBottom: 88,
  },
  title: {
    marginBottom: 18,
  },
  regular: {
    fontWeight: 400,
  },
  info: {
    display: "flex",
    alignItems: "center",
    margin: "8px 0px",
    color: "#1a2633",
    width: 120,
  },
  infoLine: {
    flex: 1,
    background: "#60768e",
    height: 1,
    fontSize: 0,
    lineHeight: 0,
    margin: "0px 16px",
  },
  body: {
    marginTop: 24,
    // marginBottom: 172,
  },
  bodybol: {
    // marginTop: 32,
    marginBottom: 32,
  },
  bodybol2: {
    marginTop: 32,
    marginBottom: 32,
  },
  half: {
    width: "50%",
  },
  bold: {
    fontWeight: 600,
    // color: "#60768e",
  },
  content: {
    marginTop: 32,
  },
  content2: {
    marginTop: 32,
    minHeight: 100,
  },
  title1: {
    width: 65,
    color: "#60768e",
  },
  title2: {
    width: 120,
    color: "#60768e",
  },
  viewtitle: {
    color: "#60768e",
  },
  contentGraph1: {
    width: 46,
    height: 24,
    background: "#ff8686",
  },
  contentGraph2: {
    width: 46,
    height: 24,
    background: "#ffb986",
  },
  contentGraphRight: {
    width: 100,
    textAlign: "center",
  },
  em: {
    color: "#10459a",
    fontWeight: 700,
  },
  subCon: {
    marginTop: 24,
    marginBottom: 52,
    "& > h4": {
      paddingTop: 12,
    },
  },
  defaultHeight: {
    height: "12mm",
    // borderLeft: "1px solid #e3e3e3",
    borderBottom: "1px solid #e3e3e3",
  },
  defaultTitleHeight: {
    height: "12mm",
    // borderLeft: "1px solid #e3e3e3",
    borderBottom: "1px solid #e3e3e3",
  },
  largedefaultHeight: {
    height: "15mm",
    // borderLeft: "1px solid #e3e3e3",
    borderBottom: "1px solid #e3e3e3",
  },
  largeTitleHeight: {
    height: "15mm",
    // borderLeft: "1px solid #e3e3e3",
    borderBottom: "1px solid #e3e3e3",
  },
  lastHeight: {
    height: "12mm",
  },
  lastdefaultHeight: {
    height: "12mm",
    // borderLeft: "1px solid #e3e3e3",
  },
  colStyle: {
    height: "12mm",
    borderBottom: "1px solid #e3e3e3",
  },
};
class PrintResult extends React.Component {
  render() {
    const {
      meyper,
      meAgeAroundPer,
      cancer,
      fullMode,
      meDefaultAgeAroundPer,
      queData,
      sex,
    } = this.props;
    // const grapHeight1 = (per) => {
    //   if (per === 0) {
    //     return <div style={printStyle.grapLine1}></div>;
    //   } else if (0 < per && per <= 0.1) {
    //     return <div style={printStyle.grapLine11}></div>;
    //   } else if (0.1 < per && per <= 0.2) {
    //     return <div style={printStyle.grapLine12}></div>;
    //   } else if (0.2 < per && per <= 0.5) {
    //     return <div style={printStyle.grapLine13}></div>;
    //   } else if (0.5 < per && per <= 1.0) {
    //     return <div style={printStyle.grapLine14}></div>;
    //   } else if (1.0 < per && per <= 1.5) {
    //     return <div style={printStyle.grapLine15}></div>;
    //   } else if (2 < per && per <= 5) {
    //     return <div style={printStyle.grapLine16}></div>;
    //   } else {
    //     return <div style={printStyle.grapLine17}></div>;
    //   }
    // };
    // const grapHeight = (per) => {
    //   if (per === 0) {
    //     return <div style={printStyle.grapLine2}></div>;
    //   } else if (0 < per && per <= 0.1) {
    //     return <div style={printStyle.grapLine21}></div>;
    //   } else if (0.1 < per && per <= 0.2) {
    //     return <div style={printStyle.grapLine22}></div>;
    //   } else if (0.2 < per && per <= 0.5) {
    //     return <div style={printStyle.grapLine23}></div>;
    //   } else if (0.5 < per && per <= 1.0) {
    //     return <div style={printStyle.grapLine24}></div>;
    //   } else if (1.0 < per && per <= 1.5) {
    //     return <div style={printStyle.grapLine25}></div>;
    //   } else if (2 < per && per <= 5) {
    //     return <div style={printStyle.grapLine26}></div>;
    //   } else {
    //     return <div style={printStyle.grapLine27}></div>;
    //   }
    // };
    // const grapHeight3 = (per) => {
    //   if (per === 0) {
    //     return <div style={printStyle.grapLine3}></div>;
    //   } else if (0 < per && per <= 0.1) {
    //     return <div style={printStyle.grapLine31}></div>;
    //   } else if (0.1 < per && per <= 0.2) {
    //     return <div style={printStyle.grapLine32}></div>;
    //   } else if (0.2 < per && per <= 0.5) {
    //     return <div style={printStyle.grapLine33}></div>;
    //   } else if (0.5 < per && per <= 1.0) {
    //     return <div style={printStyle.grapLine34}></div>;
    //   } else if (1.0 < per && per <= 1.5) {
    //     return <div style={printStyle.grapLine35}></div>;
    //   } else if (2 < per && per <= 5) {
    //     return <div style={printStyle.grapLine36}></div>;
    //   } else {
    //     return <div style={printStyle.grapLine37}></div>;
    //   }
    // };
    const mulVal = cancer == "유방암" ? 1.2 : 1.5;
    const years = cancer == "유방암" ? 5 : 9;    
    const breastValues = [meyper, meAgeAroundPer].sort();
    const breastGraphScale = 20 / breastValues[1];
    return (
      <Grid
        container
        justify="center"
        alignItems="center"
        direction="column"
        style={printStyle.root}
      >
        <Grid container justify="flex-end" alignItems="center">
          <Grid style={printStyle.logo}></Grid>
        </Grid>
        <Grid style={printStyle.detail}>
          <Grid style={printStyle.detailCont}>
            <Typography align="left">
              본 자료는 근거에 기반한 환자중심의 의사결정 (Evidence-based
              Patient-centered Decision Making)
              <br />을 돕고자 개발된&nbsp;
              <span style={printStyle.bold}>
                한국형 {cancer} 검진 자가 의사결정도구의 결과지
              </span>
              입니다.
              <br />
              대한암협회 홈페이지에 탑재되어 있는 의사결정도구
              (https://cancer-screening-e0c6e.web.app) 에 환자가 작성한 내용을
              바탕으로 계산된 결과가 아래에 출력되어 있습니다.
            </Typography>
          </Grid>
          <Grid style={printStyle.detailCont}>
            <Typography align="left">
              <span style={printStyle.bold}>1) 개인별 암 발생위험도*</span>
              <br />
              - 국민건강보험공단 자료를 바탕으로 구축된 예측모형을 이용하여
              &nbsp;{years}년내 암 발생위험도 계산
              <br />- 포함변수:
              {cancer === "유방암" 
                ? "나이, 성별, 체질량지수, 당뇨, 고혈압, 이상지질혈증, 흡연, 음주, 운동, 출산, 모유수유, 월경 시작 연령, 유방 양성 종양, 유방실질 분포량, 폐경 여부, 유방암 가족력"
                : cancer === "전립선암"
                ? "나이, 흡연력, 체질량지수, 당뇨, 고혈압 진단여부, 규칙적 운동여부"
                : "나이, 성별, 흡연력, 체질량지수, 당뇨, 폐기종/만성폐쇄성폐질환, 결핵 진단여부"}
            </Typography>
          </Grid>
          <Grid style={printStyle.detailContSub}>
            {cancer === "유방암" ? null 
              : cancer === "전립선암" ? (
              <>
                * Yeo Y, Shin DW, Lee J, Han K, Park SH, Jeon KH, Shin J, Shin
                A, Park J. Personalized 5-Year Prostate Cancer Risk Prediction
                Model in <br />
                Korea Based on Nationwide Representative Data. J Pers Med. 2021
                Dec 21;12(1):2. doi: 10.3390/jpm12010002.
              </>
            ) : (
              <>
                {" "}
                * Yeo Y, Shin DW, Han K, Park SH, Jeon KH, Lee J, Kim J, Shin A.
                Individual 5-Year Lung Cancer Risk Prediction Model in <br />
                Korea Using a Nationwide Representative Database. Cancers
                (Basel). 2021 Jul 13;13(14):3496. doi: 10.3390/cancers13143496
              </>
            )}
          </Grid>
          <Grid style={printStyle.detailCont}>
            <Typography align="left">
              <span style={printStyle.bold}>2) 가치와 선호도 확인</span>
              <br />- 질병에 대한 정보(정의, 검진방법, 검진의 이득과 위험 등)를
              제공한 후 개인의 가치/선호도를 확인
            </Typography>
          </Grid>
          <Grid style={printStyle.detailCont2}>
            <Typography align="left">
              {cancer} 검진을 받을지 여부의 결정에 본 자료가 도움이 되길
              바랍니다.
            </Typography>
          </Grid>
        </Grid>
        <Grid style={printStyle.detail2}>
          <Grid style={printStyle.detail2Header}>
            <Typography align="center">
              <span style={printStyle.bold}>{cancer} 발생 위험도 결과</span>
            </Typography>
          </Grid>
          <Grid style={printStyle.detail2Body}>
            <Grid style={printStyle.detail2Body1}>
              <Typography align="center">
                <span style={printStyle.bold}>{years}년 내 {cancer} 발생 위험도</span>
              </Typography>
            </Grid>
            <Grid
              container
              justify="center"
              alignItems="center"
              style={printStyle.detail2Body2}
            >
              <Grid style={printStyle.detail2Left}>
                <Grid style={printStyle.grapTitle}>발생확률</Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.grap}
                >
                  <Grid
                    style={printStyle.grapLineHeight}
                    container
                    justify="center"
                    alignItems="flex-end"
                  >
                    <div style={printStyle.grapLine1}>
                      <div style={{ height: cancer == "유방암" ? (meyper * breastGraphScale) + 'mm' : (parseInt(heightCheckermm(meyper).replace('mm', '')) * mulVal) + 'mm' }}></div>
                    </div>
                  </Grid>
                  <Grid style={printStyle.grapText}>{cancer == "유방암" ? meyper.toFixed(3) : meyper}%</Grid>
                </Grid>
              </Grid>
              <Grid style={printStyle.detail2Right}>
                <Grid style={printStyle.grapTitle}>
                  비슷한 연령대 평균 발생률
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.grap}
                >
                  <Grid
                    style={printStyle.grapLineHeight}
                    container
                    justify="center"
                    alignItems="flex-end"
                  >
                    <div style={printStyle.grapLine2}>
                      <div
                        style={{ height: cancer == "유방암" ? (meAgeAroundPer * breastGraphScale) + 'mm' : (parseInt(heightCheckermm(meAgeAroundPer).replace('mm', '')) * mulVal) + 'mm' }}
                      ></div>
                    </div>
                  </Grid>
                  <Grid style={printStyle.grapText}>{cancer == "유방암" ? meAgeAroundPer.toFixed(3) : meAgeAroundPer}%</Grid>
                </Grid>
              </Grid>
              {
                meDefaultAgeAroundPer && (
                  <Grid style={printStyle.detail2Left2}>
                    <Grid style={printStyle.grapTitle}>
                      위험요인이 없는 경우 발생확률
                    </Grid>
                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      style={printStyle.grap}
                    >
                      <Grid
                        style={printStyle.grapLineHeight}
                        container
                        justify="center"
                        alignItems="flex-end"
                      >
                        <div style={printStyle.grapLine3}>
                          <div
                            style={{
                              height: (parseInt(heightCheckermm(meDefaultAgeAroundPer).replace('mm', '')) * 1.5) + 'mm',
                            }}
                          ></div>
                        </div>
                      </Grid>
                      <Grid style={printStyle.grapText}>
                        {meDefaultAgeAroundPer}%
                      </Grid>
                    </Grid>
                  </Grid>
                )
              }
            </Grid>
            <Grid style={printStyle.detail2Footer}>
              <Grid>
                <Typography align="left" style={{ fontSize: 14 }}>
                  귀하에게 {years}년 안에 &nbsp;{cancer}이 발생할 확률은&nbsp;
                  <span style={printStyle.bold}>{cancer === "유방암" ? meyper.toFixed(3) : meyper}%</span>입니다.
                  <br />
                  {cancer === "유방암" ? (
                    <>
                      귀하와 같은 나이의 여성에서 다른 위험 요인이 없는 경우 향후
                      5년간&nbsp;
                      {cancer}&nbsp;발생확률은&nbsp;
                      <span style={printStyle.bold}>{meAgeAroundPer.toFixed(3)}%</span>
                      입니다
                      <br />
                    </>                  
                  ) : cancer === "전립선암" ? (
                    <>
                      귀하와 같은 나이의 평균적인&nbsp;{sex}에서 향후
                      9년간&nbsp;
                      {cancer}&nbsp;발생확률은&nbsp;
                      <span style={printStyle.bold}>{meAgeAroundPer}%</span>
                      입니다
                      <br />
                    </>
                  ) : (
                    <>
                      귀하와 같은 나이, 성별을 가진 평균적인 분에서 향후
                      9년간&nbsp;
                      {cancer}&nbsp;발생확률은&nbsp;
                      <span style={printStyle.bold}>{meAgeAroundPer}%</span>
                      입니다
                      <br />
                    </>
                  )}
                  {cancer != "유방암" ? (
                    <>
                      귀하와 같은 나이의&nbsp;{sex}에서 다른 위험 요인이 없는 경우
                      9년안에&nbsp;{cancer}이 발생할 확률은&nbsp;
                      <span style={printStyle.bold}>
                        {meDefaultAgeAroundPer}%
                      </span>{" "}
                      입니다.
                    </>
                  ) : null}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {fullMode ? (
          <Grid style={printStyle.detail3}>
            <Grid style={printStyle.detail3Header}>
              <Typography align="center">
                <span style={printStyle.bold}>가치 선호도 평가</span>
              </Typography>
            </Grid>
            <Grid
              container
              justify="center"
              direction="column"
              alignItems="center"
            >
              <Grid
                container
                justify="center"
                alignItems="center"
                style={printStyle.colStyle}
              >
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerLine}
                ></Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">매우 중요</Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">중요</Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">약간중요</Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    중요하지
                    <br />
                    않음
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={printStyle.colStyle}
              >
                <Grid
                  container
                  // justify="center"
                  alignItems="center"
                  style={printStyle.headerLine}
                >
                  <Typography align="left">
                    &nbsp;&nbsp;치료가 가능한 시기의 {cancer}을 조기에 발견
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que1 === "a" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que1 === "b" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que1 === "c" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que1 === "d" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={printStyle.colStyle}
              >
                <Grid
                  container
                  // justify="center"
                  alignItems="center"
                  style={printStyle.headerLine}
                >
                  <Typography align="left">
                    &nbsp;&nbsp;검사에서 가짜 양성의 결과가 나올 수 있음
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que2 === "a" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que2 === "b" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que2 === "c" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que2 === "d" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={printStyle.colStyle}
              >
                <Grid
                  container
                  // justify="center"
                  alignItems="center"
                  style={printStyle.headerLine}
                >
                  <Typography align="left">
                    &nbsp;&nbsp;검사로 인한 부작용 (조직검사로 인한 합병증 발생)
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que3 === "a" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que3 === "b" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que3 === "c" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que3 === "d" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                justify="center"
                alignItems="center"
                style={printStyle.colStyle}
              >
                <Grid
                  container
                  // justify="center"
                  alignItems="center"
                  style={printStyle.headerLine}
                >
                  <Typography align="left">
                    &nbsp;&nbsp;치료에 따른 위해 발생
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que4 === "a" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que4 === "b" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que4 === "c" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  style={printStyle.headerSubLine}
                >
                  <Typography align="center">
                    {queData.que4 === "d" && (
                      <Brightness1Icon color="primary" />
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : null}
      </Grid>
    );
  }
}

class PrintViewResult extends React.Component {
  render() {
    const { data, total, cancer, fullMode, queData, large } = this.props;
    const breastResult = cancer == "유방암" ? getBreastCancerScore(data, data?.menopause == 3 || (data?.menopause == 2 && data?.age >= 50) || (!data?.menopause && data?.age >= 50) ? true : false) : null;
    const meyper =
      cancer == "유방암" ? breastResult.rate 
      :  cancer === "전립선암"
        ? year9CaseProstate20220511(total)
        : year9Case20220511(total);
    const meAgeAroundPer =
      cancer == "유방암" ? breastResult.rateAgeGroup
      : cancer === "전립선암"
        ? newProstateAgeChecker(data.age, data.sex)
        : newlungAgeChecker(data.age, data.sex);
    const meDefaultAgeAroundPer = 
      cancer == "유방암" ? null 
      : cancer === "전립선암"
        ? newDefaultProstateAgeChecker(data.age, data.sex)
        : newDefaultlungAgeChecker(data.age, data.sex);
    const sexCheckData = sexCheck(data.sex);
    const largeCase = {
      flex: 1,
      height: 78,
      fontSize: 20,
      backgroundColor: "#ffffff",
      "&:hover": {
        backgroundColor: "#ffffff",
      },
    };
    const tabletCase = {
      width: "100%",
      height: 58,
      fontSize: 18,
      backgroundColor: "#ffffff",
      "&:hover": {
        backgroundColor: "#ffffff",
      },
    };
    const mCase = {
      width: "100%",
      height: 58,
      fontSize: 18,
      backgroundColor: "#ffffff",
      "&:hover": {
        backgroundColor: "#ffffff",
      },
    };
    let cssCheck = large === 3 ? largeCase : large === 2 ? tabletCase : mCase;
    return (
      <>
      {
        cancer == '갑상선암' ? null : (
          <ReactToPrint
            trigger={() => (
              <Button style={cssCheck} variant="outlined" color="primary">
                {fullMode && large === 3
                  ? `${cancer} 발생위험도와 나의 결정 출력`
                  : "출력"}
              </Button>
            )}
            content={() => this.componentRef}
          />
        )
      }
        <div style={diplayStyle}>
          <PrintResult
            data={data}
            meyper={meyper}
            cancer={cancer}
            fullMode={fullMode}
            queData={queData}
            sex={sexCheckData}
            meAgeAroundPer={meAgeAroundPer}
            meDefaultAgeAroundPer={meDefaultAgeAroundPer}
            ref={(el) => (this.componentRef = el)}
          />
        </div>
      </>
    );
  }
}

export default PrintViewResult;
